import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ValueOf } from '../../types/base/';
import { Icon } from '../../types/icon-list.type';
import { IconComponent } from '../icon/icon.component';

export const statusIndicatorStatusOptions = {
  ERROR: 'error',
  WARN: 'warn',
  SUCCESS: 'success',
  /** default value */
  INFO: 'info',
  NEUTRAL: 'neutral',
} as const;
export type StatusIndicatorStatus = ValueOf<typeof statusIndicatorStatusOptions>;

export type StatusIndicatorType = {
  text: string;
  icon?: Icon;
  status?: StatusIndicatorStatus;
  upperCase?: boolean;
};

@Component({
  selector: 'evc-status-indicator',
  imports: [IconComponent],
  templateUrl: './status-indicator.component.html',
  styleUrls: ['./status-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusIndicatorComponent {
  public readonly text = input('');
  public readonly icon = input<Icon>();
  public readonly status = input<StatusIndicatorStatus>(statusIndicatorStatusOptions.INFO);
  public readonly upperCase = input(true);
}
